import {
  Button,
  FormInput,
  FormNumber,
  FormRoot,
  FormTextarea,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";
import type {
  CreateWorkItemTypeDTO,
  UpdateWorkItemTypeDTO,
} from "../../domain/contracts/work-item-type";

const WorkItemTypeFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາປ້ອນຊື່ປະເພດງານ"),
  description: z.string().optional().nullable(),
  orderIndex: z.number().int().default(0),
});

export type WorkItemTypeFormValues = z.infer<typeof WorkItemTypeFormSchema>;

export function WorkItemTypeForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<WorkItemTypeFormValues>;
  onSubmit: (values: CreateWorkItemTypeDTO | UpdateWorkItemTypeDTO) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<WorkItemTypeFormValues>({
    // biome-ignore lint/suspicious/noExplicitAny: zodResolver type inference issue
    resolver: zodResolver(WorkItemTypeFormSchema) as any,
    defaultValues: {
      name: "",
      description: null,
      orderIndex: 0,
      ...initialValues,
    },
  });

  return (
    <FormRoot<WorkItemTypeFormValues>
      methods={methods}
      onSubmit={(vals) =>
        onSubmit({
          name: vals.name,
          description: vals.description ?? null,
          orderIndex: vals.orderIndex ?? 0,
        })
      }
      className="space-y-4"
    >
      <FormInput
        name="name"
        label="ຊື່ປະເພດງານ"
        requiredMark
        placeholder="ຕົວຢ່າງ: ຄຳສັ່ງຊື້, ລັອດ, ບໍລິການ"
      />
      <FormTextarea
        name="description"
        label="ຄໍາອະທິບາຍ"
        placeholder="ຄໍາອະທິບາຍ (ບໍ່ບັງຄັບ)"
        rows={3}
      />
      <FormNumber
        name="orderIndex"
        label="ລໍາດັບ"
        placeholder="0"
        hint="ລໍາດັບສໍາລັບການຈັດລຽງ (ຕໍ່າກ = ສະແດງກ່ອນ)"
      />
      <div className="flex justify-end gap-2">
        <Button
          type="button"
          onClick={methods.handleSubmit(onSubmit)}
          disabled={submitting}
          isLoading={submitting}
        >
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}
